export default __webpack_public_path__ + "static/media/example-art-bad-2.c32ea3c4.webp";